import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import { useRecoilState } from 'recoil'

import { request } from '../../../../1stlog-ui/src/utils'
import { stateState, isLoadingState } from './state'

const useTemplateEditor = () => {
  const [state, setState] = useRecoilState(stateState)
  const [isLoading, setIsLoading] = useRecoilState(isLoadingState)

  const isOpen = useMemo(() => lodash.get(state, 'isOpen'), [state])
  const data = useMemo(() => lodash.get(state, 'data'), [state])

  const open = (data) => setState({ isOpen: true, data })

  const close = () => setState({ isOpen: false })

  const save = async (values) => {
    try {
      setIsLoading(true)
      const url = '/api/presets'
      const { data } = await request({
        method: 'put',
        url,
        data: values,
      })
      return data
    } finally {
      setIsLoading(false)
    }
  }

  return { isOpen, open, close, save, data, isLoading }
}

export default useTemplateEditor
